module.exports = __webpack_public_path__ + "static/media/1en.f8cd4aa7.jpg";